const scConfig = {
    /** Môi trường product */
    IS_PROD_ENV: process.env.NODE_ENV === 'production',
};

export default scConfig;
